@if (user(); as u) {
<div class="pr-root">

  <!-- Header -->
  <div class="pr-header">
    <a class="pr-back" routerLink="/leagues">← BACK TO LEAGUES</a>
    <div class="pr-header-actions">
<button class="pr-btn" (click)="logout()">Sign out</button>
    </div>
  </div>

  <!-- Body -->
  <div class="pr-body">

    <!-- LEFT: collector card + trophy case -->
    <div class="pr-left">

      <!-- Collector card -->
      <div class="pr-collector-card">
        <div class="pr-card-top">
          <div class="pr-badge">COLLECTOR · L1</div>
          <span class="pr-eyebrow">MEMBER · {{ profileData()?.stats?.memberSince ?? '—' }}</span>
        </div>

        <div class="pr-avatar-frame">
          @if (u.profile_picture) {
            <img [src]="u.profile_picture" class="pr-avatar-img" alt="avatar" referrerpolicy="no-referrer">
          } @else {
            <div class="pr-avatar-initials">{{ getInitials(u.name) }}</div>
          }
        </div>

        <div class="pr-card-info">
          <div class="pr-name">{{ u.name }}</div>
          <div class="pr-email">{{ u.email }}</div>

          <div class="pr-stats-grid">
            <div class="pr-stat">
              <div class="pr-stat-label">LEAGUES</div>
              <div class="pr-stat-value">{{ profileData()?.stats?.leagues ?? '—' }}</div>
            </div>
            <div class="pr-stat">
              <div class="pr-stat-label">DRAFTED</div>
              <div class="pr-stat-value">{{ profileData()?.stats?.drafted ?? '—' }}</div>
            </div>
            <div class="pr-stat">
              <div class="pr-stat-label">SEASONS</div>
              <div class="pr-stat-value">{{ profileData()?.binder?.length ?? '—' }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Trophy case -->
      <div class="pr-trophy-case">
        <div class="pr-section-eyebrow">TROPHY CASE</div>
        @if (isLoading()) {
          <div class="pr-empty-state">Loading…</div>
        } @else if ((profileData()?.binder?.length ?? 0) === 0) {
          <div class="pr-empty-state">No seasons tracked yet.</div>
        } @else {
          @for (entry of profileData()!.binder; track entry.leagueId; let i = $index) {
            <div class="pr-trophy-row" [class.pr-trophy-row--last]="$last">
              <span class="pr-trophy-year">{{ entry.year }}</span>
              <span class="pr-trophy-league">{{ entry.leagueName }}</span>
              <span class="pr-trophy-team">{{ entry.teamName }}</span>
            </div>
          }
        }
      </div>

    </div>

    <!-- RIGHT: binder -->
    <div class="pr-binder">

      <!-- Binder header -->
      <div class="pr-binder-header">
        <div>
          <div class="pr-eyebrow">THE BINDER · ALL DRAFTED PLAYERS</div>
          <h3 class="pr-binder-title">
            {{ profileData()?.binder?.length ?? 0 }} season{{ (profileData()?.binder?.length ?? 0) !== 1 ? 's' : '' }} ·
            {{ profileData()?.stats?.drafted ?? 0 }} cards
          </h3>
        </div>
      </div>

      @if (isLoading()) {
        <div class="pr-loading">Loading binder…</div>
      } @else if (!currentBinder()) {
        <div class="pr-binder-empty">
          <p>Your binder is empty — draft some players to fill it up.</p>
          <a class="pr-btn pr-btn--solid" routerLink="/leagues">Go to leagues</a>
        </div>
      } @else {

        <!-- Current season -->
        <div class="pr-season-section">
          <div class="pr-season-header">
            <div class="pr-season-label">
              <span class="pr-dot"></span>
              {{ currentBinder()!.year }} · {{ currentBinder()!.leagueName }} · {{ currentBinder()!.teamName.toUpperCase() }}
            </div>
            <span class="pr-season-meta">
              ${{ currentBinder()!.totalSpent }} SPENT · {{ currentBinder()!.slotsUsed }} / {{ currentBinder()!.rosterSize }} SLOTS
            </span>
          </div>
          <div class="pr-cards-grid pr-cards-grid--8">
            @for (p of currentBinder()!.players; track $index; let i = $index) {
              <app-player-card
                [player]="toCardData(p)"
                [posColor]="tone(i)"
                [nameAbbrev]="true">
              </app-player-card>
            }
          </div>
        </div>

        <!-- Archive -->
        @if (archiveBinder().length > 0) {
          <div class="pr-archive-section">
            <div class="pr-archive-header">
              <div class="pr-eyebrow">ARCHIVE · PAST SEASONS</div>
            </div>
            @for (b of archiveBinder(); track b.leagueId) {
              <div class="pr-archive-league">
                <div class="pr-season-label" style="margin-bottom: 8px;">
                  <span class="pr-dot"></span>
                  {{ b.year }} · {{ b.leagueName }} · {{ b.teamName.toUpperCase() }}
                </div>
                <div class="pr-cards-grid pr-cards-grid--12">
                  @for (p of b.players; track $index; let i = $index) {
                    <app-player-card
                      [player]="toCardData(p)"
                      [posColor]="tone(i)"
                      [nameAbbrev]="true">
                    </app-player-card>
                  }
                </div>
              </div>
            }
          </div>
        }

      }
    </div>

  </div>
</div>
}
